<template>
    <div class="drawbox" v-if="visible">
        <canvas width="320" height="320" class="drawCanvas" ref="drawCanvas" @touchstart="startDrawing" @touchmove="draw" @touchend="stopDrawing" @touchcancel="stopDrawing" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing" @mouseleave="stopDrawing"></canvas>
        <div class="toolbar">
            <input type="color" id="brushColour" v-model="colour"/>
            <input type="range" id="brushSize" min="1" max="20" v-model="brushSize"/>
            <button class="button-default" @click="undo"><FAIcon icon="undo" /></button>
            <button class="button-default" @click="clear"><FAIcon icon="trash" /></button>
            <button class="button-default" @click="upload"><FAIcon icon="upload" /></button>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faUndo, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons'
    library.add(faUndo, faTrash, faUpload)
    export default {
        props: ['visible'],
        data() {
            return {
                drawing: false,
                colour: '#ffffff',
                brushSize: 5,
                drawingHist: [],
                currentLine: []
            };
        },
        methods: {
            startDrawing(event) {
                const canvas = this.$refs.drawCanvas;
                const ctx = canvas.getContext('2d');

                this.drawing = true;
                event.preventDefault();
                ctx.lineJoin = 'round';
                ctx.lineCap = 'round';
                ctx.lineWidth = this.brushSize;
                ctx.strokeStyle = this.colour;

                ctx.beginPath();
                const { x, y } = this.inputPos(event);
                ctx.moveTo(x, y);
                
                this.currentLine = {
                    points: [{ x, y }],
                    colour: this.colour,
                    brushSize: this.brushSize
                };
            },
            draw(event) {
                if (!this.drawing) return;
                const canvas = this.$refs.drawCanvas;
                const ctx = canvas.getContext('2d');
                event.preventDefault();
                
                const { x, y } = this.inputPos(event);
                ctx.lineTo(x, y);
                ctx.stroke();
                this.currentLine.points.push({ x, y });
            },
            stopDrawing() {
                if (!this.drawing) return;
                this.drawing = false;
                this.drawingHist.push(this.currentLine);
                this.currentLine = [];
            },
            undo() {
                if (this.drawingHist.length > 0) {
                    this.drawingHist.pop();
                    const canvas = this.$refs.drawCanvas;
                    const ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    
                    for (const drawing of this.drawingHist) {
                        ctx.beginPath();
                        ctx.lineWidth = drawing.brushSize;
                        ctx.strokeStyle = drawing.colour;

                        const points = drawing.points;
                        ctx.moveTo(points[0].x, points[0].y);
                        for (const point of points) {
                            ctx.lineTo(point.x, point.y);
                        }
                        ctx.stroke();
                    }
                }
            },
            clear() {
                const canvas = this.$refs.drawCanvas;
                const ctx = canvas.getContext('2d');

                ctx.clearRect(0, 0, canvas.width, canvas.height);
                this.drawingHist = [];
                this.currentLine = [];
            },
            upload() {
                const canvas = this.$refs.drawCanvas;
                const dataURL = canvas.toDataURL('image/png');
                this.$emit('postDrawing', dataURL);
            },
            inputPos(event) {
                const canvas = this.$refs.drawCanvas;
                let x, y;
                if (event.touches) {
                    const touch = event.touches[0];
                    const rect = canvas.getBoundingClientRect();
                    x = touch.clientX - rect.left;
                    y = touch.clientY - rect.top;
                } else {
                    x = event.offsetX;
                    y = event.offsetY;
                }
                return { x, y };
            },
        }
    };
</script>

<style>
    .drawCanvas {
        border: 2px solid var(--border);
        border-radius: var(--btnRadius);
        margin-top: 4px;
    }
    .drawbox {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .toolbar {
        display: flex;
        max-width: 320px;
    }
    .toolbar button {
        width: 30px;
        margin: 0px 0.2em;
    }
    .toolbar input[type="range"] {
        -webkit-appearance: none;
        align-self: center;
        height: 4px;
        margin: 0px 4px;
        border-radius: 2px;
        background: var(--btn);
        &::-webkit-slider-thumb {
            background: var(--link);
            height: 12px;
            width: 12px;
        }
        &::-webkit-slider-runnable-track {
            background: var(--link);
        }
        &::-moz-range-thumb {
            background: var(--link);
            height: 12px;
            width: 12px;
        }
        &::-moz-range-progress {
            background: var(--link);
        }
    }
</style>
